import { render, staticRenderFns } from "./CourseForm.vue?vue&type=template&id=487f8e5a"
import script from "./CourseForm.vue?vue&type=script&lang=js"
export * from "./CourseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487f8e5a')) {
      api.createRecord('487f8e5a', component.options)
    } else {
      api.reload('487f8e5a', component.options)
    }
    module.hot.accept("./CourseForm.vue?vue&type=template&id=487f8e5a", function () {
      api.rerender('487f8e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/manytomany/CourseForm.vue"
export default component.exports